<template>
  <div class>
    <STable
      ref="tableref"
      :url="url"
      :columns="columns"
      :handles="handles"
      :query="query"
      :selection="false"
      :toolbar="toolbar"
      labelWidth="120px"
    ></STable>
  </div>
</template>

<script>
import fieldFilter from "@/utils/fieldFilter.js";
export default {
  name: "projectManagement",
  components: {},
  data() {
    return {
      url: "/battery/dcProject/page",
      columns: [
        {
          label: "项目名称",
          prop: "name",
        },
        {
          label: "企业名称",
          prop: "companyName",
        },
        {
          label: "创建人",
          prop: "creatorName",
        },
        {
          label: "创建时间",
          prop: "createTime",
        }
      ],
      // 操作栏
      handles: {
        width: 300,
        btns: [
          {
            label: "修改",
            style: "color:#00CC00",
            permission: "projectmanagement.pageupdate",
            handle: (resp) => {
              this.$router.push({
                path: "./modifyProject",
                query: { data: resp },
              });
            },
          },
          {
            label:"删除",
            style:"color:red",
            permission:"projectmanagement.delete",
            url:"/battery/dcProject/delete",
            method:"delete",
            isConfirm: true,
            before:(index,record) => {
            return {
                id:record.id
            };
            },
            handle: () =>{
                this.$refs.tableref.queryTable();
            }
          }
        ],
      },
      query: [
        {
          label: "项目名称",
          prop: "name",
          placeholder: "请输入项目名称",
        },
        {
          label: "企业名称",
          prop: "companyName",
          placeholder: "请输入企业名称",
        }
      ],
      toolbar: [
        {
          label: "新增",
          type: "success",
          permission:"projectmanagement.pageadd",
          handle: resp => {
            this.$router.push("./addProject")
          }
        }
      ],
    };
  },
  computed: {},
  methods: {
  },
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang="less" src="" scoped>
</style>



// WEBPACK FOOTER //
// src/views/BMS/deviceManagement/projectManagement.vue